import { Component } from '@angular/core';

@Component({
  selector: 'ngx-metiers',
  template: `<router-outlet></router-outlet>`,
})
export class MetiersComponent {
}
